import * as React from "react";
const SvgQuickMapIcon = props => <svg width="1em" height="1em" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M11 0h5v5h-5V3h-.938l-3.507 7H5v2H0V7h5v2h.938l3.507-7H11V0ZM4 11V8H1v3h3Zm11-7V1h-3v3h3Z" /></svg>;
export default SvgQuickMapIcon;